// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63422185","431":"5566af71","455":"a612742a","488":"2a049007","977":"ba62ba2e"}[chunkId] + ".chunk.js";
};